export default function CaretUp({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0343 9.64C16.3907 9.64 16.5691 10.0709 16.3172 10.3228L12.2828 14.3572C12.1266 14.5134 11.8734 14.5134 11.7172 14.3572L7.68284 10.3228C7.43086 10.0709 7.60932 9.64 7.96569 9.64H16.0343Z"
        fill="currentColor"
        transform="rotate(180 12 12)"
      />
    </svg>
  )
}
